import Vue from 'vue'
import Router from 'vue-router'
import AppContainer from './views/AppContainer.vue'
import store from './store.js'
import permissionCheck from "./util/ACL/permissionCheck"
import permissionMap from './util/ACL/permissionMap.js'
import piincHttp from '@/util/configureAxios.js'

Vue.use(Router)

// An activity is shown on its process's page (US 9369 + 9371): /activities/view/:slug opens
// /processes/view/:process/activities/:slug. An activity without a process keeps its own page.
function activityGuard (to, from, next) {
  if (!store.state.isLoggedIn) {
    return guard(to, from, next);
  }
  piincHttp.get('activities/' + to.params.slug + '/switcher').then(function(response) {
    if (response.data && response.data.parent) {
      next({ name: 'processes.activity', params: { process: response.data.parent.slug, slug: to.params.slug }, query: to.query, replace: true });
    } else {
      guard(to, from, next);
    }
  }, function() {
    guard(to, from, next);
  });
}

// Check if user is logged in before entering the state
function guard (to, from, next) {
  if (store.state.isLoggedIn) {

    // Check if trial has ended and redirect to billing page
    setTimeout(function() {
      var moment = require('moment');
      let currentDate = moment()

      if (store.state.client && store.state.client.id) {
        let endDate = moment(store.state.client.trial_ends_at);
        let difference = endDate.diff(currentDate, 'days');

        if ((store.state.client.subscription_status == 'trial_expired' && difference < 1) || store.state.client.subscription_status == 'subscription_ended') {
          next('/client/' + store.state.client.slug + '?tabindex=1');
        }
      } else {
        let client = {};
        if (store.state.clientSlug && store.state.clientSlug.length) {
          piincHttp.get('clients/' + store.state.clientSlug + '/trial').then(function(response) {
            client = response.data
            let endDate = moment(client.trial_ends_at);
            let difference = endDate.diff(currentDate, 'days');

            if ((client.subscription_status == 'trial_expired' && difference < 1) || client.subscription_status == 'subscription_ended') {
              next('/client/' + store.state.clientSlug + '?tabindex=1');
            }
          }, function() {});
        }
      }
    }, 500);

    // If route is on maintenance
    if (to.path.startsWith('/maintenance')) {
      if (store.state.user && store.state.user.id) {
        if (permissionCheck(permissionMap.MAINTENANCE_VIEW) || store.state.user.isAdmin) {

          if (to.params.client || to.query.client) {
            let selectedClient = {};
            let self = this;

            if (to.params.client) {
              _.forEach(store.state.user.clients, function(client) {
                if(client.slug == to.params.client){
                  selectedClient = client;
                }
              })

              piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
                selectedClient.user_permissions = response.data.user_permissions
                selectedClient.user_roles = response.data.user_roles
                localStorage.setItem('clientObject', JSON.stringify(selectedClient));
                localStorage.setItem('client', selectedClient.slug);
                store.commit('storeClient', selectedClient);
                setTimeout(function(){
                  next();
                }, 400);
              }, function() {});
            }
            if (to.query.client) {

              let interval = setInterval( function () {
                if (store.state.user && store.state.user.id && store.state.user.clients) {
                  // If everything is set up, clear interval
                  clearInterval(interval)

                  _.forEach(store.state.user.clients, function(client) {
                    if(client.slug == to.query.client){
                      selectedClient = client;
                    }
                  })

                  piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
                    selectedClient.user_permissions = response.data.user_permissions
                    selectedClient.user_roles = response.data.user_roles
                    localStorage.setItem('clientObject', JSON.stringify(selectedClient));
                    localStorage.setItem('client', selectedClient.slug);
                    store.commit('storeClient', selectedClient);
                    setTimeout(function(){
                      next();
                    }, 400);
                  }, function() {});

                }
              }, 200);

            }

          } else {
            next(); // allow to enter route
          }
        } else {
          // Redirect to 403 if there are no given roles
          next('/403');
        }
      } else {
        // Check if client permissions are received every 300 ms
        let interval = setInterval( function () {
          if (store.state.user && store.state.user.id && store.state.client.user_permissions) {
            // If everything is set up, check for permissions
            clearInterval(interval)
            if (permissionCheck(permissionMap.MAINTENANCE_VIEW) || store.state.user.isAdmin) {
              next();
            } else {
              // Redirect to 403 if there are no given roles
              next('/403');
            }
          }
        }, 300);
      }
    } else if (to.path.startsWith('/administration')) {
      // Wait until the signed-in user has loaded before deciding: a super admin's users/me lists
      // every client and can take seconds, and a fixed 800 ms wait sent them to 403 (US 9436)
      let waited = 0;
      let interval = setInterval(function () {
        waited += 100;
        let user = store.state.user;
        if ((user && user.id) || waited >= 30000) {
          clearInterval(interval);
          // Only super admins may go to administration
          if (user && user.isAdmin) {
            next();
          } else {
            next('/403');
          }
        }
      }, 100);

    } else {
      if (to.params.client || to.query.client) {
        let selectedClient = {};
        let self = this;

        if (to.params.client) {
          _.forEach(store.state.user.clients, function(client) {
            if(client.slug == to.params.client){
              selectedClient = client;
            }
          })

          piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
            selectedClient.user_permissions = response.data.user_permissions
            selectedClient.user_roles = response.data.user_roles
            localStorage.setItem('clientObject', JSON.stringify(selectedClient));
            localStorage.setItem('client', selectedClient.slug);
            store.commit('storeClient', selectedClient);
            setTimeout(function(){
              next();
            }, 400);
          }, function() {});
        }
        if (to.query.client) {
          let interval = setInterval( function () {
            if (store.state.user && store.state.user.id && store.state.user.clients) {
              // If everything is set up, clear interval
              clearInterval(interval)

              _.forEach(store.state.user.clients, function(client) {
                if(client.slug == to.query.client){
                  selectedClient = client;
                }
              })

              piincHttp.get('users/me/permissions/' + selectedClient.slug).then(function(response) {
                selectedClient.user_permissions = response.data.user_permissions
                selectedClient.user_roles = response.data.user_roles
                localStorage.setItem('clientObject', JSON.stringify(selectedClient));
                localStorage.setItem('client', selectedClient.slug);
                store.commit('storeClient', selectedClient);
                setTimeout(function(){
                  next();
                }, 400);
              }, function() {});

            }
          }, 200);
        }

      } else {
        next(); // allow to enter route
      }
    }
  } else {
    store.commit('storeHistoryPage', to.fullPath);
    next('/login'); // go to '/login';
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      // App view, with children views
      path: '/',
      component: AppContainer,
      children: [
        {
          path: '/',
          beforeEnter: guard, // Using guard before entering the route
          name: 'Home',
          // route level code-splitting
          // this generates a separate chunk ([component].[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue')
        },
        {
          path: '/profile/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'profile',

          component: () => import(/* webpackChunkName: "Profile" */ './views/Profile/Profile.vue')
        },
        {
          path: '/client/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'clientProfile',

          component: () => import(/* webpackChunkName: "ClientProfile" */ './views/Profile/ClientProfile.vue')
        },
        {
          path: '/notifications',
          beforeEnter: guard, // Using guard before entering the route
          name: 'notifications',

          component: () => import(/* webpackChunkName: "Processes" */ './components/notification/NotificationPage.vue'),
        },
        {
          path: '/risk-scenarios',
          beforeEnter: guard, // Using guard before entering the route
          name: 'risk_scenarios',

          component: () => import(/* webpackChunkName: "Processes" */ './views/RiskScenarios/RiskScenarios.vue'),
        },
        {
          path: '/risk-scenarios/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'risk_scenarios.create',

          component: () => import(/* webpackChunkName: "Create Process" */ './views/RiskScenarios/CreateRiskScenario.vue')
        },
        {
          path: '/risk-scenarios/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'risk_scenarios.view',

          component: () => import(/* webpackChunkName: "View Process" */ './views/RiskScenarios/RiskScenarioView.vue')
        },
        {
          path: '/tasks',
          beforeEnter: guard, // Using guard before entering the route
          name: 'tasks',

          component: () => import(/* webpackChunkName: "Tasks" */ './views/Tasks/Tasks.vue'),
        },
        {
          path: '/regulatory',
          beforeEnter: guard, // Using guard before entering the route
          name: 'regulatory',

          component: () => import(/* webpackChunkName: "Regulatory" */ './views/Dashboard/Regulatory.vue'),
        },
        {
          path: '/tree-view',
          beforeEnter: guard, // Using guard before entering the route
          name: 'treeView',

          component: () => import(/* webpackChunkName: "TreeView" */ './views/Dashboard/TreeView.vue'),
        },
        {
          path: '/validations',
          beforeEnter: guard, // Using guard before entering the route
          name: 'validations',

          component: () => import(/* webpackChunkName: "Validations" */ './views/Dashboard/Validations.vue'),
        },
        {
          path: '/risk-matrix',
          beforeEnter: guard, // Using guard before entering the route
          name: 'riskMatrix',

          component: () => import(/* webpackChunkName: "RiskMatrix" */ './views/Dashboard/RiskMatrix.vue'),
        },
        {
          path: '/policies',
          beforeEnter: guard, // Using guard before entering the route
          name: 'policies',

          component: () => import('./views/Policies/Policies.vue')
        },
        {
          path: '/policies/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'policies.view',

          component: () => import('./views/Policies/PolicyView.vue')
        },
        {
          path: '/policies/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'policies.create',

          component: () => import('./views/Policies/CreatePolicy.vue')
        },
        {
          path: '/processing-activities',
          beforeEnter: guard, // Using guard before entering the route
          name: 'processes',

          component: () => import(/* webpackChunkName: "Processes" */ './views/Processes/ProcessingMap.vue'),
        },
        {
          path: '/processes/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'processes.create',

          component: () => import(/* webpackChunkName: "Create Process" */ './views/Processes/CreateProcess.vue')
        },
        {
          path: '/processes/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'processes.view',

          component: () => import(/* webpackChunkName: "View Process" */ './views/Processes/ProcessView.vue')
        },
        {
          path: '/systems',
          beforeEnter: guard, // Using guard before entering the route
          name: 'systems',

          component: () => import(/* webpackChunkName: "Systems" */ './views/Systems/Systems.vue')
        },
        {
          path: '/systems/import',
          beforeEnter: guard, // Using guard before entering the route
          name: 'systems.import',

          component: () => import(/* webpackChunkName: "Systems" */ './views/Systems/ImportSystems.vue')
        },
        {
          path: '/systems/contract-links',
          beforeEnter: guard, // Using guard before entering the route
          name: 'systems.contract_links',

          component: () => import(/* webpackChunkName: "Systems" */ './views/Systems/SortContractLinks.vue')
        },
        {
          // Systems are added in a panel on the systems page (US 9370); the old address opens it there
          path: '/systems/create',
          name: 'systems.create',
          redirect: { name: 'systems', query: { create: '1' } }
        },
        {
          path: '/systems/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'systems.view',

          component: () => import(/* webpackChunkName: "View System" */ './views/Systems/SystemView.vue')
        },
        {
          path: '/generic-controls',
          beforeEnter: guard, // Using guard before entering the route
          name: 'generic_controls',

          component: () => import(/* webpackChunkName: "GenericControls" */ './views/GenericControls/GenericControls.vue')
        },
        {
          path: '/generic-controls/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'generic_controls.create',

          component: () => import(/* webpackChunkName: "Create Generic Control" */ './views/GenericControls/CreateGenericControl.vue')
        },
        {
          path: '/generic-controls/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'generic_controls.view',

          component: () => import(/* webpackChunkName: "View Generic Control" */ './views/GenericControls/GenericControlsView.vue')
        },
        {
          path: '/activities',
          beforeEnter: guard, // Using guard before entering the route
          name: 'activities',

          component: () => import(/* webpackChunkName: "Activities" */ './views/Activities/Activities.vue')
        },
        {
          path: '/activities/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'activities.create',

          component: () => import(/* webpackChunkName: "Create Activity" */ './views/Activities/CreateActivity.vue')
        },
        {
          path: '/shared-links',
          beforeEnter: guard, // Using guard before entering the route
          name: 'shared_links',

          component: () => import(/* webpackChunkName: "Processes" */ './views/Processes/SharedLinks.vue')
        },
        {
          path: '/processes/view/:process/activities/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'processes.activity',

          component: () => import(/* webpackChunkName: "View Activity" */ './views/Activities/ActivityView.vue')
        },
        {
          path: '/activities/view/:slug',
          beforeEnter: activityGuard,
          name: 'activities.view',

          component: () => import(/* webpackChunkName: "View Activity" */ './views/Activities/ActivityView.vue')
        },
        {
          path: 'projects/asset-projects',
          redirect: {path: '/projects', query: {view: 'list', family: 'records'}}
        },
        {
          path: 'projects/control-projects',
          redirect: {path: '/projects', query: {view: 'list', family: 'controls'}}
        },
        {
          path: 'projects/assessment-projects',
          redirect: {path: '/projects', query: {view: 'list', family: 'assessments'}}
        },
        {
          path: 'incidents',
          beforeEnter: guard, // Using guard before entering the route
          name: 'IncidentsList',

          component: () => import(/* webpackChunkName: "IncidentsList" */ './views/Incidents/IncidentsList.vue')
        },
        {
          path: '/incidents/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'incidents.view',

          component: () => import(/* webpackChunkName: "View Incident" */ './views/Incidents/IncidentView.vue')
        },
        {
          path: '/projects',
          beforeEnter: guard, // Using guard before entering the route
          name: 'projects',

          component: () => import(/* webpackChunkName: "ProjectManagement" */ './views/Projects/ProjectManagement.vue')
        },
        // The Gantt and the three project lists are views of the Project management page (US 9396)
        {
          path: '/projects/gantt',
          redirect: {path: '/projects'}
        },
        {
          path: '/projects/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'projects.view',

          component: () => import(/* webpackChunkName: "View Project" */ './views/Projects/ProjectView.vue')
        },
        {
          path: 'projects/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'projects.create',

          component: () => import(/* webpackChunkName: "Create Project" */ './views/Projects/CreateProject.vue')
        },
        {
          // The contracts list is the Third parties list grouped by contract now (US 9371)
          path: '/contracts',
          name: 'contracts',
          redirect: { name: 'contracts.third_parties', query: { group: 'contract' } }
        },
        {
          path: '/contracts/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.view',

          component: () => import(/* webpackChunkName: "Maintenance ContractsView" */ './views/ThirdParty/ThirdPartiesView.vue')
        },
        {
          path: '/contracts/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.create',

          component: () => import(/* webpackChunkName: "Maintenance CreateContracts" */ './views/ThirdParty/CreateThirdParty.vue')
        },
        {
          path: '/third-parties',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.third_parties',

          component: () => import(/* webpackChunkName: "Maintenance ThirdParties" */ './views/ThirdParty/ThirdPartiesList.vue')
        },
        {
          path: '/third-parties/view/:slug',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.third_parties.view',

          component: () => import(/* webpackChunkName: "Maintenance ThirdPartyView" */ './views/ThirdParty/VendorsView.vue')
        },
        {
          path: '/third-parties/create',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.third_parties.create',

          component: () => import(/* webpackChunkName: "Maintenance CreateThirdParty" */ './views/ThirdParty/CreateVendor.vue')
        },
        {
          path: '/third-parties/upload-agreement',
          beforeEnter: guard, // Using guard before entering the route
          name: 'contracts.agreement_upload',

          component: () => import(/* webpackChunkName: "Maintenance AgreementUpload" */ './views/ThirdParty/page/AgreementUpload.vue')
        },
        {
          path: '/maintenance',
          beforeEnter: guard, // Using guard before entering the route
          name: 'maintenance',

          component: () => import(/* webpackChunkName: "Maintenance" */ './views/Maintenance/Maintenance.vue'),
          children:[
            {
              path: '/maintenance',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.dashboard',

              component: () => import(/* webpackChunkName: "Maintenance Overview" */ './views/Maintenance/MaintenanceOverview.vue')
            },
            {
              path: '/maintenance/partitions',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.partitions',

              component: () => import(/* webpackChunkName: "Maintenance Users" */ './views/Partitions/Partitions.vue')
            },
            {
              path: '/maintenance/reports/:media?',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.reports',

              component: () => import(/* webpackChunkName: "Maintenance Reports" */ './views/Reports/Reports.vue')
            },
            {
              // Partitions are created in a modal on the list (US 9365)
              path: '/maintenance/partitions/create',
              name: 'maintenance.createPartition',
              redirect: { name: 'maintenance.partitions' }
            },
            {
              // The partition page with its details and members (US 9365)
              path: '/maintenance/partitions/view/:slug',
              name: 'maintenance.partitionView',
              redirect: { name: 'maintenance.partitionMembers' }
            },
            {
              path: '/maintenance/partitions/view/:slug/members',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.partitionMembers',

              component: () => import(/* webpackChunkName: "ClientMembers" */ './views/Partitions/PartitionMembers.vue')
            },
            {
              path: '/maintenance/users',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.users',

              component: () => import(/* webpackChunkName: "Maintenance Users" */ './views/Users/Users.vue')
            },
            {
              path: '/maintenance/users/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.createUser',

              component: () => import(/* webpackChunkName: "Maintenance CreateUser" */ './views/Users/CreateUser.vue')
            },
            {
              path: '/maintenance/data-objects',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_objects',

              component: () => import('./views/DataObjects/DataObjects.vue')
            },
            {
              path: '/maintenance/data-objects/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_objects.view',

              component: () => import('./views/DataObjects/DataObjectView.vue')
            },
            {
              path: '/maintenance/data-objects/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_objects.create',

              component: () => import('./views/DataObjects/CreateDataObject.vue')
            },
            {
              path: '/maintenance/information-obligation',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.information_obligation',

              component: () => import('./views/InformationObligation/InformationObligation.vue')
            },
            {
              path: '/maintenance/information-obligation/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.information_obligation.view',

              component: () => import('./views/InformationObligation/InformationObligationView.vue')
            },
            {
              path: '/maintenance/information-obligation/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.information_obligation.create',

              component: () => import('./views/InformationObligation/CreateInformationObligation.vue')
            },
            {
              path: '/maintenance/legal-basis',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.legal_basis',

              component: () => import('./views/LegalBasis/LegalBasis.vue')
            },
            {
              path: '/maintenance/legal-basis/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.legal_basis.view',

              component: () => import('./views/LegalBasis/LegalBasisView.vue')
            },
            {
              path: '/maintenance/legal-basis/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.legal_basis.create',

              component: () => import('./views/LegalBasis/CreateLegalBasis.vue')
            },
            {
              path: '/maintenance/access-control',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.access_control',

              component: () => import('./views/AccessControl/AccessControl.vue')
            },
            {
              path: '/maintenance/access-control/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.access_control.view',

              component: () => import('./views/AccessControl/AccessControlView.vue')
            },
            {
              path: '/maintenance/access-control/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.access_control.create',

              component: () => import('./views/AccessControl/CreateAccessControl.vue')
            },
            {
              path: '/maintenance/log-management',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.log_management',

              component: () => import('./views/LogManagement/LogManagement.vue')
            },
            {
              path: '/maintenance/log-management/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.log_management.view',

              component: () => import('./views/LogManagement/LogManagementView.vue')
            },
            {
              path: '/maintenance/log-management/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.log_management.create',

              component: () => import('./views/LogManagement/CreateLogManagement.vue')
            },
            {
              path: '/maintenance/data-discovery',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_discovery',

              component: () => import('./views/DataDiscovery/DataDiscovery.vue')
            },
            {
              path: '/maintenance/data-discovery/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_discovery.view',

              component: () => import('./views/DataDiscovery/DataDiscoveryView.vue')
            },
            {
              path: '/maintenance/data-discovery/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_discovery.create',

              component: () => import('./views/DataDiscovery/CreateDataDiscovery.vue')
            },
            {
              path: '/maintenance/network',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.network',

              component: () => import('./views/Network/Networks.vue')
            },
            {
              path: '/maintenance/network/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.network.view',

              component: () => import('./views/Network/NetworkView.vue')
            },
            {
              path: '/maintenance/network/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.network.create',

              component: () => import('./views/Network/CreateNetwork.vue')
            },
            {
              path: '/maintenance/data-subjects',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_subjects',

              component: () => import('./views/DataSubjects/DataSubjects.vue')
            },
            {
              path: '/maintenance/data-subjects/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_subjects.view',

              component: () => import('./views/DataSubjects/DataSubjectView.vue')
            },
            {
              path: '/maintenance/data-subjects/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.data_subjects.create',

              component: () => import('./views/DataSubjects/CreateDataSubject.vue')
            },
            {
              path: '/maintenance/retention-rules',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.retention_rules',

              component: () => import('./views/RetentionRules/RetentionRules.vue')
            },
            {
              path: '/maintenance/retention-rules/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.retention_rules.view',

              component: () => import('./views/RetentionRules/RetentionRuleView.vue')
            },
            {
              path: '/maintenance/retention-rules/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.retention_rules.create',

              component: () => import('./views/RetentionRules/CreateRetentionRule.vue')
            },
            {
              path: '/maintenance/incident-categories',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.incident_categories',

              component: () => import('./views/Incidents/IncidentCategories.vue')
            },
            {
              path: '/maintenance/incident-categories/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.incident_categories.view',

              component: () => import('./views/Incidents/IncidentCategoryView.vue')
            },
            {
              path: '/maintenance/measures',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.measures',

              component: () => import('./views/Measures/Measures.vue')
            },
            {
              path: '/maintenance/measures/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.measures.view',

              component: () => import('./views/Measures/MeasureView.vue')
            },
            {
              path: '/maintenance/measures/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.measures.create',

              component: () => import('./views/Measures/CreateMeasure.vue')
            },
            {
              path: '/maintenance/measures/measure-categories',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.measures.categories',

              component: () => import('./views/Measures/MeasureCategories.vue')
            },
            {
              path: '/maintenance/process-groups',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.process_groups',

              component: () => import('./views/ProcessGroups/ProcessGroups.vue')
            },
            {
              path: '/maintenance/process-groups/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.process_groups.create',

              component: () => import('./views/ProcessGroups/CreateProcessGroup.vue')
            },
            {
              path: '/maintenance/organizations',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.organizations',

              component: () => import('./views/Organizations/Organizations.vue')
            },
            {
              path: '/maintenance/organizations/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.organizations.view',

              component: () => import('./views/Organizations/OrganizationView.vue')
            },
            {
              path: '/maintenance/organizations/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.organizations.create',

              component: () => import('./views/Organizations/CreateOrganization.vue')
            },
            {
              path: '/maintenance/frameworks',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.frameworks',

              component: () => import('./views/Frameworks/Frameworks.vue')
            },
            {
              path: '/maintenance/frameworks/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.frameworks.view',

              component: () => import('./views/Frameworks/FrameworkView.vue')
            },
            {
              path: '/maintenance/frameworks/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.frameworks.create',

              component: () => import('./views/Frameworks/CreateFramework.vue')
            },
            {
              path: '/maintenance/threats',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.threats',

              component: () => import('./views/Threats/Threats.vue')
            },
            {
              path: '/maintenance/threats/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.threats.view',

              component: () => import('./views/Threats/ThreatView.vue')
            },
            {
              path: '/maintenance/threats/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.threats.create',

              component: () => import('./views/Threats/CreateThreat.vue')
            },
            {
              path: '/maintenance/vulnerabilities',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.vulnerabilities',

              component: () => import('./views/Vulnerabilities/Vulnerabilities.vue')
            },
            {
              path: '/maintenance/vulnerabilities/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.vulnerabilities.view',

              component: () => import('./views/Vulnerabilities/VulnerabilityView.vue')
            },
            {
              path: '/maintenance/vulnerabilities/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.vulnerabilities.create',

              component: () => import('./views/Vulnerabilities/CreateVulnerability.vue')
            },
            {
              path: '/maintenance/risk-categories',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.risk_categories',

              component: () => import('./views/RiskCategories/RiskCategories.vue')
            },
            {
              path: '/maintenance/risk-categories/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.risk_categories.view',

              component: () => import('./views/RiskCategories/RiskCategoryView.vue')
            },
            {
              path: '/maintenance/risk-categories/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.risk_categories.create',

              component: () => import('./views/RiskCategories/CreateRiskCategory.vue')
            },
            {
              path: '/maintenance/assessment-templates',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.assessments',

              component: () => import('./views/Assessments/Assessments.vue')
            },
            {
              path: '/maintenance/assessment-templates/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.assessments.view',

              component: () => import('./views/Assessments/AssessmentView.vue')
            },
            {
              path: '/maintenance/assessment-templates/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'maintenance.assessments.create',

              component: () => import('./views/Assessments/CreateAssessment.vue')
            },
          ]
        },
        {
          path: '/administration',
          beforeEnter: guard, // Using guard before entering the route
          name: 'administration',

          component: () => import(/* webpackChunkName: "Administration" */ './views/Administration/Administration.vue'),

          children:[
            {
              path: '/administration',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.dashboard',

              component: () => import(/* webpackChunkName: "AdministrationOverview" */ './views/Administration/AdministrationOverview.vue')
            },
            {
              path: '/administration/clients',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.clients',

              component: () => import(/* webpackChunkName: "Clients" */ './views/Administration/Clients.vue')
            },
            {
              path: '/administration/clients/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.createClient',

              component: () => import(/* webpackChunkName: "CreateClient" */ './views/Administration/CreateClient.vue')
            },
            {
              path: '/administration/clients/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.clientView',

              component: () => import(/* webpackChunkName: "ClientProfile" */ './views/Profile/ClientProfile.vue')
            },
            {
              path: '/administration/guide',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.guide',

              component: () => import(/* webpackChunkName: "Guide" */ './views/Administration/Guide.vue')
            },
            {
              path: '/administration/guide/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.createGuide',

              component: () => import(/* webpackChunkName: "CreateGuide" */ './views/Administration/CreateGuide.vue')
            },
            {
              path: '/administration/guide/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.guideView',

              component: () => import(/* webpackChunkName: "GuideView" */ './views/Administration/GuideView.vue')
            },
            {
              path: '/administration/clients/view/:slug/members',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.clientMembers',

              component: () => import(/* webpackChunkName: "ClientMembers" */ './views/Administration/ClientMembers.vue')
            },
            {
              path: '/administration/users',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.users',

              component: () => import(/* webpackChunkName: "Users" */ './views/Administration/Users.vue')
            },
            {
              path: '/administration/users/view/:slug',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.userView',

              component: () => import(/* webpackChunkName: "UserView" */ './views/Administration/UserView.vue')
            },
            {
              path: '/administration/users/create',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.createUser',

              component: () => import(/* webpackChunkName: "CreateUser" */ './views/Administration/CreateUser.vue')
            },
            {
              path: '/administration/settings',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.settings',

              component: () => import(/* webpackChunkName: "Settings" */ './views/Administration/Settings.vue')
            },
            {
              path: '/administration/features',
              beforeEnter: guard, // Using guard before entering the route
              name: 'administration.features',

              component: () => import(/* webpackChunkName: "Features" */ './views/Administration/Features.vue')
            }
          ]
        },
        {
          path: '/404',
          name: '404',
          component: () => import('./views/ErrorPages/404.vue')
        },
        {
          path: '/403',
          name: '403',
          component: () => import('./views/ErrorPages/403.vue')
        }
      ]
    },
    // Login as a separate screen, divided from the app view
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "Login" */ './views/Auth/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "Register" */ './views/Auth/Register.vue')
    },
    {
      path: '/token/:token',
      name: 'Token',

      component: () => import(/* webpackChunkName: "Token" */ './views/Token.vue')
    },
    {
      path: '/email/verify/:token/:email',
      name: 'verify',

      component: () => import(/* webpackChunkName: "Verify" */ './views/Verify.vue')
    },
    {
      path: '/checkout/cancel/:client/:token',
      name: 'CheckoutCancel',

      component: () => import(/* webpackChunkName: "CheckoutCancel" */ './views/CheckoutCancel.vue')
    },
    {
      path: '/checkout/success/:client/:token',
      name: 'CheckoutSuccess',

      component: () => import(/* webpackChunkName: "CheckoutSuccess" */ './views/CheckoutSuccess.vue')
    },
    {
      path: '/downloads/:media',
      name: 'Downloads',

      component: () => import(/* webpackChunkName: "Downloads" */ './views/Downloads.vue')
    },
    {
      path: '/maintenance-page',
      name: 'MaintenancePage',

      component: () => import(/* webpackChunkName: "MaintenancePage" */ './views/MaintenancePage.vue')
    },
    {
      path: '/styleguide',
      name: 'Styleguide',

      component: () => import(/* webpackChunkName: "Styleguide" */ './views/Styleguide.vue')
    },
    {
      path: '/password/reset/:token',
      name: 'resetPassword',
      component: () => import(/* webpackChunkName: "resetPassword" */ './views/Auth/ResetPassword.vue')
    },
    {
      path: '*',
      name: 'NotFound',
      component: () => import('./views/ErrorPages/404.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {

  // redirect to login page if not logged in and trying to access a restricted page
  let authorize = to.meta.permissions ? to.meta.permissions: '';
  if (authorize) {
    // Get the current user from the store
    let client = store.state.client;
    let hasPermission = false;

    authorize.forEach(function (value) {
      // Loop through all user permissions
      Vue._.forEach(client.user_permissions, function (permission) {
        // If given permission is in user permissions array, set hasPermission to true
        if (permission.name === value) {
          hasPermission = true;
        }
      })
    });
    // check if route is restricted by role
    if (!hasPermission) {
      // role not authorised so redirect to home page
      return next('/403');
    }
  }

  next();
})

export default router
